import { Pipe, PipeTransform } from '@angular/core';

import moment from 'moment';

import { SettingsService } from 'src/app/services/settings/settings.service';
import { UrlParametersService } from 'src/app/services/urlParameters/url-parameters.service';

@Pipe({ name: 'time' })
export class TimePipe implements PipeTransform {
  constructor(
    private readonly settingsService: SettingsService,
    public parametersService: UrlParametersService
  ) {}

  transform(time: string, inputFormat = 'h:mm', ignoreUTC = false): string {
    const { timeFormatPattern } = this.settingsService.settings.dateTimeFormat;
    return (ignoreUTC ? moment.utc(time, inputFormat) : moment(time, inputFormat)).format(timeFormatPattern) || '';
  }
}
